// MACHINERY V2 (Stroje) — fleet page notices (M2.2).
//
// Two small message surfaces the fleet needs, split out of FleetV1Page for the
// 300-line cap:
//
//   Notice     — the centred empty / loading / not-yet-built panel.
//   FilterNote — an amber inline banner explaining why a filter the user set is
//                NOT in effect right now (review F4: status filters are
//                telemetry-derived, and the decommissioned scope has no
//                telemetry). The rule it serves: never silently clear the
//                user's filter, and never silently match nothing.
//
// No Tailwind, no shadcn, no MUI, no @emotion, no sx, no dt tokens.
import React from "react";

export const Notice: React.FC<{ text: string; dashed?: boolean }> = ({
  text,
  dashed = true,
}) => (
  <div
    style={{
      padding: "28px 20px",
      textAlign: "center",
      color: "var(--muted)",
      border: dashed ? "1px dashed var(--border)" : 0,
      borderRadius: 12,
      background: dashed ? "var(--card)" : "transparent",
    }}
  >
    {text}
  </div>
);

export const FilterNote: React.FC<{ text: string }> = ({ text }) => (
  <div
    style={{
      marginBottom: 14,
      padding: "9px 12px",
      borderRadius: 8,
      background: "color-mix(in oklab, var(--amber) 10%, var(--card))",
      border: "1px solid color-mix(in oklab, var(--amber) 30%, var(--border))",
      color: "var(--ink-2)",
      fontSize: 12,
    }}
  >
    {text}
  </div>
);

export default Notice;
